import { render } from "./ClickIcon.vue?vue&type=template&id=7dff3340&scoped=true"
import script from "./ClickIcon.vue?vue&type=script&lang=js"
export * from "./ClickIcon.vue?vue&type=script&lang=js"

import "./ClickIcon.vue?vue&type=style&index=0&id=7dff3340&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dendro-plots/dendro-plots/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dff3340"]])

export default __exports__